<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { FilterField, TableField } from "../../../../../components/table/table";
import { Permission } from '../../../../../types/auth'
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import WarehouseShelfsForm from './WarehouseShelfsForm.vue';

const props = withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
  data?: any[],
  unit_of_measures?: any | [],
  warehouse?: any | null
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = "/clients/system/company/warehouses/shelf-";
const title = 'Shelfs'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const rows = ref<any[]>(props.data || [])

const fields: TableField[] = [
  { name: 'code', caption: 'Code', sortable: true, fieldType: 'text' },
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}

watch(() => props.data || [], (newValue) => {
  console.log('shelf list', newValue, props.data)
  if (newValue) {
    rows.value = newValue
  } else {
    rows.value = []
  }
})

onMounted(() => {
  console.log("data -warehouse shelf", props.data)
  console.log('warehoiuse', props.warehouse)
})

const handleShelfs = (data: any[]) => {
  if (data) {
    rows.value = data;
  }
}

const permissions = ref<Permission[]>(props.permissions || [])
</script>

<template>
  <ListTemplate  :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" :ignore-permissions="true"
  @data="handleData" :data="rows" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" :perm="permissions">
  <template #form-view>
    <WarehouseShelfsForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :warehouse="warehouse"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="handleShelfs"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>